import { get } from '@api/request';

export default {};
